import moment from "moment";
import { mapGetters, mapState } from "vuex";

export const ReviewCategoriesChartMixin = {
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    title: {
      type: String
    },
    fieldName: {
      type: String,
      required: true
    },
    fetchMethod: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters("reviewsCategoriesAnalytics", [
      "getFacilityParams",
      "getSelectedDate",
      "getComparisonDate"
    ]),
    ...mapState({
      selectedCategory: state =>
        state.reviewsCategoriesAnalytics.selectedCategory
    }),
    filters() {
      return {
        ...this.getFacilityParams,
        ...this.getSelectedDate,
        ...this.getComparisonDate,
        ...{ tag_id: this.$route.query.tag_id }
      };
    }
  },
  methods: {
    chartLabelsHandler(array) {
      if ("month" in array[0]) {
        return array.map(item => {
          return `${moment()
            .month(item.month - 1)
            .year(item.year)
            .format("MMM YYYY")}`;
        });
      } else {
        const dateArray = [];

        array.forEach(item => {
          const weekStartDate = moment()
            .year(item.year)
            .week(item.week)
            .startOf("week");
          const weekDateRange = `${weekStartDate.format(
            "DD.MM.YYYY"
          )} - ${weekStartDate.add(6, "days").format("DD.MM.YYYY")}`;
          dateArray.push(weekDateRange);
        });
        return dateArray;
      }
    },
    getChartLabels(basic, comparison) {
      const basicData = basic;
      const comparisonData = comparison;

      const basicLabels = basicData.length
        ? this.chartLabelsHandler(basicData)
        : [];
      const comparisonLabels = comparisonData.length
        ? this.chartLabelsHandler(comparisonData)
        : [];
      const mergedLabels = basicLabels.map((item, index) => {
        return `${item || ""};${comparisonLabels[index] || ""} `;
      });
      return mergedLabels;
    }
  },
  watch: {
    filters: {
      async handler() {
        await this.getChartData(this.chartFilter);
      },
      deep: true,
      immediate: true
    }
  }
};
